import styled from 'styled-components'

import theme from 'theme_'

export const SubscriptionEndDate = styled.div<{ hasWarning: boolean }>`
  ${(p) =>
    p.hasWarning &&
    `
    color: ${theme.colors.error};
  `}
`
